import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import WhoWeAre from './components/WhoWeAre';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import CTABanner from './components/CTABanner';
import Testimonials from './components/Testimonials';
import RequestQuote from './components/RequestQuote';
import FAQ from './components/FAQ';
import ContactServiceAreas from './components/ContactServiceAreas';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Introduction />
      <WhoWeAre />
      <Services />
      <WhyChooseUs />
      <Gallery />
      <CTABanner />
      <Testimonials />
      <RequestQuote />
      <FAQ />
      <ContactServiceAreas />
      <Footer />
    </div>
  );
}
